import type { IconName } from "@/lib/icons";

export type Integration = {
  name: string;
  icon: IconName;
  category: "Channel" | "CRM" | "Scheduling" | "Commerce" | "Data" | "Comms" | "Automation";
};

/**
 * Tools we genuinely integrate with — the honest replacement for fake client
 * logos (§5.5, §10). Only list integrations that are actually true.
 */
export const integrations: Integration[] = [
  { name: "WhatsApp", icon: "MessageCircle", category: "Channel" },
  { name: "Twilio", icon: "Phone", category: "Channel" },
  { name: "HubSpot", icon: "Boxes", category: "CRM" },
  { name: "Calendly", icon: "Calendar", category: "Scheduling" },
  { name: "Shopify", icon: "ShoppingBag", category: "Commerce" },
  { name: "Google Sheets", icon: "Table2", category: "Data" },
  { name: "Notion", icon: "StickyNote", category: "Data" },
  { name: "Slack", icon: "Hash", category: "Comms" },
  { name: "Zapier", icon: "Zap", category: "Automation" },
];
